import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-my-xl text-justify" }
const _hoisted_2 = { class: "text-bold text-subtitle2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "gt-sm" }
const _hoisted_7 = { class: "row q-mb-xl" }
const _hoisted_8 = { class: "row justify-start q-px-sm" }
const _hoisted_9 = { class: "PurpleToWhite q-px-lg" }
const _hoisted_10 = { class: "lt-md" }
const _hoisted_11 = { class: "row justify-between no-print q-px-sm q-mt-lg" }
const _hoisted_12 = { class: "PurpleToWhite q-px-lg" }
const _hoisted_13 = {
  key: 0,
  class: "PurpleToWhite q-px-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SolutionTab = _resolveComponent("SolutionTab")!
  const _component_MedsTab = _resolveComponent("MedsTab")!
  const _component_ResultTab = _resolveComponent("ResultTab")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Osmolarity.Introduction.Title")), 1),
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Osmolarity.Introduction.P1")), 1),
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Osmolarity.Introduction.P2")), 1),
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Osmolarity.Introduction.P3")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SolutionTab, {
            onClick: _cache[0] || (_cache[0] = () => { _ctx.focusTab(1); }),
            onSolutionsChanged: _cache[1] || (_cache[1] = (solutions) => { _ctx.updateSolutions(solutions); }),
            onResetForm: _cache[2] || (_cache[2] = () => { _ctx.solutionResetIndex += 1 }),
            parentSolutions: _ctx.solutions,
            resetIndex: _ctx.solutionResetIndex
          }, null, 8, ["parentSolutions", "resetIndex"]),
          _createVNode(_component_MedsTab, {
            onClick: _cache[3] || (_cache[3] = () => { _ctx.focusTab(2); }),
            onSolutionsChanged: _cache[4] || (_cache[4] = (solutions) => { _ctx.updateAdditives(solutions); }),
            onResetForm: _cache[5] || (_cache[5] = () => { _ctx.medsResetIndex += 1 }),
            parentSolutions: _ctx.additives,
            resetIndex: _ctx.medsResetIndex
          }, null, 8, ["parentSolutions", "resetIndex"]),
          _createVNode(_component_ResultTab, {
            onClick: _cache[6] || (_cache[6] = () => { _ctx.focusTab(3); }),
            solutions: _ctx.solutions,
            additives: _ctx.additives
          }, null, 8, ["solutions", "additives"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              flat: "",
              onClick: _cache[7] || (_cache[7] = () => { _ctx.routerBack() }),
              style: {"width":"100%"},
              class: "text-bold text-subtitle1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" < " + _toDisplayString(_ctx.$t('PreviousButton')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.currentTab === 1)
          ? (_openBlock(), _createBlock(_component_SolutionTab, {
              key: 0,
              mobile: "",
              onClick: _cache[8] || (_cache[8] = () => { _ctx.focusTab(1); }),
              onSolutionsChanged: _cache[9] || (_cache[9] = (solutions) => { _ctx.updateSolutions(solutions); }),
              onResetForm: _cache[10] || (_cache[10] = () => { _ctx.solutionResetIndex += 1 }),
              parentSolutions: _ctx.solutions,
              resetIndex: _ctx.solutionResetIndex
            }, null, 8, ["parentSolutions", "resetIndex"]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 2)
          ? (_openBlock(), _createBlock(_component_MedsTab, {
              key: 1,
              mobile: "",
              onClick: _cache[11] || (_cache[11] = () => { _ctx.focusTab(2); }),
              onSolutionsChanged: _cache[12] || (_cache[12] = (solutions) => { _ctx.updateAdditives(solutions); }),
              onResetForm: _cache[13] || (_cache[13] = () => { _ctx.medsResetIndex += 1 }),
              parentSolutions: _ctx.additives,
              resetIndex: _ctx.medsResetIndex
            }, null, 8, ["parentSolutions", "resetIndex"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ResultTab, {
          style: _normalizeStyle(_ctx.currentTab === 3 ? '' : 'display: none'),
          mobile: "",
          onClick: _cache[14] || (_cache[14] = () => { _ctx.focusTab(3); }),
          solutions: _ctx.solutions,
          additives: _ctx.additives
        }, null, 8, ["style", "solutions", "additives"]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              flat: "",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.previousPage())),
              style: {"width":"100%"},
              class: "text-bold text-subtitle1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" < " + _toDisplayString(_ctx.$t('PreviousButton')), 1)
              ]),
              _: 1
            })
          ]),
          (_ctx.currentTab < 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  flat: "",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.nextPage())),
                  style: {"width":"100%"},
                  class: "text-bold text-subtitle1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('NextButton')) + " > ", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}